import Vue from 'vue'
import store from '@/store'

Vue.directive('check-permission', {
  inserted(el, binding, node) {
    const permissions = Array.isArray(binding.value) ? binding.value : [binding.value]
    const requireAll = !!binding.modifiers.all
    const checker = requireAll
      ? store.getters['permissions/hasAllSubuserPermissions']
      : store.getters['permissions/hasAnySubuserPermission']

    if (!checker(permissions.filter(Boolean))) {
      node.elm.parentElement.removeChild(node.elm)
    }
  },
})
